Ext.define('SA.CrosstabView', {
    alias: 'widget.crosstab-view',
    extend: 'Ext.Component',

    childEls: ['tableTarget', 'loadMaskTarget'],

    renderTpl: [
        '<div id="{id}-tableTarget" class="sa-crosstab-view-table-target"></div>',
        '<div id="{id}-loadMaskTarget" class="sa-crosstab-view-load-mask-target"></div>'
    ],

    afterRender() {
        this.callParent();

        this.loadMask = Ext.widget({
            xtype: 'load-mask',
            backgroundColor: '#fdfdfd',
            renderTo: this.loadMaskTarget,
            spinnerSize: 'large'
        });
    },

    getTableTarget() {
        return this.tableTarget.dom;
    },

    removeLoadMask() {
        Ext.destroyMembers(this, 'loadMaskTarget', 'loadMask');
    }
});